<div class="container-fluid">
  <div class="row">
    <div class="col-md-3 col-lg-2 col-12">
      <div class="form-floating mb-3 mt-5">
        <select
          class="form-select"
          [(ngModel)]="workingLocationFilter"
          (change)="employeeFilter($event, 'location')"
        >
          <option value="" selected hidden>Select a Working Location</option>
          <option value="all">All</option>
          <option *ngFor="let location of WorkingLocationList">
            {{ location }}
          </option>
        </select>
        <label>Working Location</label>
      </div>
    </div>

    <div class="col-md-3 col-lg-2 col-12">
      <div class="form-floating mb-3 mt-5">
        <select
          class="form-select"
          [(ngModel)]="employeeTypeFilter"
          (change)="employeeFilter($event, 'employee')"
        >
          <option value="" selected hidden>Select a Employee Type</option>
          <option value="all">All</option>
          <option *ngFor="let employee of employeeTypeList">
            {{ employee }}
          </option>
        </select>
        <label>Employee Type</label>
      </div>
    </div>

    <div class="col-md-3 col-lg-2 col-12">
      <div class="form-floating mb-3 mt-5">
        <select
          class="form-select"
          [(ngModel)]="designationFilter"
          (change)="employeeFilter($event, 'designation')"
        >
          <option value="" selected hidden>Select a Designation</option>
          <option value="all">All</option>
          <option *ngFor="let designation of designationList">
            {{ designation }}
          </option>
        </select>
        <label>Designation</label>
      </div>
    </div>

    <div class="col-md-3 col-lg-2 col-12">
      <div class="form-floating mb-3 mt-5">
        <select
          class="form-select"
          [(ngModel)]="workingStatusFilter"
          (change)="employeeFilter($event, 'status')"
        >
          <option value="" selected hidden>Select a Working Status</option>
          <option value="all">All</option>
          <option *ngFor="let status of workingStatus">{{ status }}</option>
        </select>
        <label>Working Status</label>
      </div>
    </div>

    <div class="col-md-4 col-lg-2 col-12">
      <div class="form-floating mb-3 mt-5">
        <input
          type="text"
          class="form-control"
          placeholder="Search.."
          [(ngModel)]="searchText"
        />
        <label>Search</label>
      </div>
    </div>

    <div
      class="col-md-1 col-lg-1 col-12 d-flex align-items-center justify-content-end mt-4"
    >
      <button
        class="btn btn-danger"
        (click)="clearFilter()"
        title="Clear Filters"
      >
        Clear Filter<i class="fa fa-trash ms-2"></i>
      </button>
    </div>
  </div>

  <div class="col-12 table-responsive mt-2 table-wrapper-scroll-y tableFixHead">
    <table class="table table-bordered table-hover table-rounded text-center">
      <thead class="sticky-top table-primary">
        <tr>
          <th>S.No</th>
          <th>Employee ID</th>
          <th>Employee Name</th>
          <th>Employee Location</th>
          <th>Employee Type</th>
          <th>Designation</th>
          <th>Working Status</th>
          <th>View</th>
          <!-- <th class="text-center">New Joining Letter</th>
          <th class="text-center">Experience Certificate</th> -->
          <th>Edit</th>
          <th>Print</th>
        </tr>
      </thead>
      <tbody *ngIf="filteredEmployees.length > 0; else noDataFound">
        <tr
          *ngFor="
            let forms of filteredEmployees | filter: searchText;
            let i = index
          "
        >
          <td>{{ i + 1 }}</td>
          <td>{{ forms?.newJoinId || "-" }}</td>
          <td>{{ forms?.employeeName || "-" }}</td>
          <td>{{ forms?.location || "-" }}</td>
          <td>{{ forms?.employeeType || "-" }}</td>
          <td>{{ forms?.designation || "-" }}</td>
          <td>{{ forms?.workingStatus || "-"}}</td>
          <td>
            <i
              class="fa fa-eye"
              title="Click to View the Report"
              (click)="openModel(forms?.newJoinId)"
            ></i>
          </td>
          <td class="text-center">
            <button
              class="btn btn-primary rounded-pill"
              data-toggle="modal"
              data-target="#exampleModalCenter"
              (click)="editDetails(forms?.formId)"
            >
              Edit
            </button>
          </td>
          <td>
            <i class="fa fa-print" (click)="print(forms?.newJoinId)"></i>
          </td>
        </tr>
      </tbody>
      <ng-template #noDataFound>
        <tr>
          <td colspan="12">Data Not Found</td>
        </tr>
      </ng-template>
    </table>
  </div>
</div>

<div
  class="modal bg-light bg-opacity-50"
  id="exampleModalCenter"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
  [style.display]="isMapShow ? 'block' : 'none'"
>
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Document</h5>
        <button
          data-toggle="tooltip"
          data-placement="top"
          title="Close"
          type="button"
          class="close text-danger"
          data-dismiss="modal"
          aria-label="Close"
          (click)="close()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" id="imagesUrl"></div>
    </div>
  </div>
</div>

<div
  class="modal bg-light bg-opacity-50"
  id="exampleModalCenter1"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
  [style.display]="isViewShow ? 'block' : 'none'"
>
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content" id="printableArea">
      <div class="modal-header">
        <h5 class="modal-title">Employee Details</h5>
        <button
          *ngIf="this.viewDocument"
          data-toggle="tooltip"
          data-placement="top"
          title="Close"
          type="button"
          class="close text-danger"
          data-dismiss="modal"
          aria-label="Close"
          (click)="close1()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body tablemodel">
        <div class="table-responsive" *ngFor="let getdata of this.employeeData">
          <table class="table table-bordered table-hover">
            <tbody>
              <tr>
                <th>Employee Id</th>
                <td>{{ getdata?.newJoinId }}</td>
              </tr>
              <tr>
                <th>Employee Type</th>
                <td>{{ getdata?.employeeType }}</td>
              </tr>
              <tr>
                <th>Employee Working Location</th>
                <td>{{ getdata?.location }}</td>
              </tr>
              <tr>
                <th>Employee Joining Date</th>
                <td>{{ getdata?.employeeJoiningDate }}</td>
              </tr>
              <tr>
                <th>Employee Name</th>
                <td>{{ getdata?.employeeName }}</td>
              </tr>
              <tr>
                <th>Employee Father Name</th>
                <td>{{ getdata?.employeeFatherName }}</td>
              </tr>
              <tr>
                <th>Gender</th>
                <td>{{ getdata?.gender }}</td>
              </tr>
              <tr>
                <th>Date Of Birth</th>
                <td>{{ getdata?.dateOfBirth }}</td>
              </tr>
              <tr>
                <th>Employee Age</th>
                <td>{{ getdata?.age }}</td>
              </tr>
              <tr>
                <th>Designation</th>
                <td>{{ getdata?.designation }}</td>
              </tr>
              <tr>
                <th>Qualification</th>
                <td>{{ getdata?.qualification }}</td>
              </tr>
              <tr>
                <th>Address</th>
                <td>{{ getdata?.address }}</td>
              </tr>
              <tr>
                <th>Employee Location</th>
                <td>{{ getdata?.employeeLocation }}</td>
              </tr>
              <tr>
                <th>Blood Group</th>
                <td>{{ getdata?.bloodGroup }}</td>
              </tr>
            </tbody>
            <tbody *ngIf="bankDetails">
              <tr>
                <th>Aadhar No</th>
                <td>{{ getdata?.aadharNo }}</td>
              </tr>
              <tr>
                <th>Bank Name</th>
                <td>{{ getdata?.bankName }}</td>
              </tr>
              <tr>
                <th>Branch Name</th>
                <td>{{ getdata?.branchName }}</td>
              </tr>
              <tr>
                <th>Bank IFSC Code</th>
                <td>{{ getdata?.bankIfscCode }}</td>
              </tr>
              <tr>
                <th>Bank Holder Name</th>
                <td>{{ getdata?.nameAsInPassbook }}</td>
              </tr>
              <tr>
                <th>Account Number</th>
                <td>{{ getdata?.accountNo }}</td>
              </tr>
              <tr>
                <th>Employee Contact Number</th>
                <td>{{ getdata?.employeeContactNo }}</td>
              </tr>
              <tr>
                <th>Emergency Contact Number</th>
                <td>{{ getdata?.emergencyContactNo }}</td>
              </tr>
              <tr>
                <th>Working Status</th>
                <td>{{ getdata?.workingStatus }}</td>
              </tr>
              <tr>
                <th>Allowed Leave Days</th>
                <td>{{ getdata?.allowedLeaveDays }}</td>
              </tr>
              <tr>
                <th>Min Leave Policy</th>
                <td>{{ getdata?.minimumLeavePolicy }}</td>
              </tr>
              <tr>
                <th>Salary Type</th>
                <td>{{ getdata?.salaryType }}</td>
              </tr>
              <tr>
                <th>Employee Salary</th>
                <td>{{ getdata?.salaryValueFixed }}</td>
              </tr>
            </tbody>
            <tbody *ngIf="getdata?.assetDetails.length != 0">
  <tr>
    <th>Documents</th>
    <td class="text-primary">
      <p *ngFor="let image of getdata?.assetDetails">
        <span *ngIf="image?.documentType === 'AADHARCARD'" 
              (click)="photoView(image?.assetId)"
              style="cursor:pointer">
          Aadhar card
        </span>
        <span *ngIf="image?.documentType === 'PANCARD'" 
              (click)="photoView(image?.assetId)"
              style="cursor:pointer">
          Pan card
        </span>
        <span *ngIf="image?.documentType === 'BANKPASSBOOK'" 
              (click)="photoView(image?.assetId)"
              style="cursor:pointer">
          Bank Passbook
        </span>
        <span *ngIf="image?.documentType === 'PROFILE'" 
              (click)="photoView(image?.assetId)"
              style="cursor:pointer">
          Profile
        </span>
      </p>
    </td>
  </tr>
</tbody>


          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ngx-spinner>
  <div class="loader">
    <div class="inner one"></div>
    <div class="inner two"></div>
    <div class="inner three"></div>
  </div>
</ngx-spinner>
